$(document).ready(function () {
	$('body').find('.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();

		// Toggle direct parent
		$(this).parent().toggleClass('show');
	});
});
